import axiosApi from "api/root.api";

export const loginGet = async () => {
  const urlEnd = "/editor/statistics/v1/project/calculate";
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
